<template>
    <transition name="modal">
        <div class="modal-mask">
            <div class="modal-wrapper" @click="$emit('close')">
                <div class="modal-container-enregistrer" @click.stop>
                    <div class="modal-header-enregistrer">
                        {{ $t('_enregistrer_brouillon_') }}
                        <slot name="cross">
                            <v-icon style="float: right; top: 0.3vh;" @click="$emit('close')">mdi-close</v-icon>
                        </slot>
                    </div>

                    <div class="modal-body-enregistrer">
                        <v-label style="color: black; font-weight: bold;"> {{ $t('_nom_') }}</v-label>
                        <v-text-field outlined class="inputField" v-model="nom">

                        </v-text-field>
                    </div>

                    <div class="modal-footer-enregistrer">
                        <v-btn style="float: right; background-color: #F49301; padding: 1vh; font-size: 1rem"
                            @click="saveAndClose">
                            {{ $t('_enregistrer_') }}
                        </v-btn>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>

export default {

    data() {
        return {
            nom: "",
        }
    },

    methods: {
        saveAndClose() {
            this.$emit('save', this.nom);
            this.$emit('close');
            this.nom = "";
        }
    }
}


</script>

<style scoped>

.modal-container-enregistrer {
    width: 40vw;
    height: 25vh;
    /* max-height: 80vh;
    min-height: 30vh; */
    margin: 0px auto;
    padding: 2vh;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    border-radius: 0.25rem;
    position: relative;
    flex-direction: column;
}

.modal-header-enregistrer {
    font-weight: bold;
    font-size: 1.5rem;
    color: #212121;
    height: fit-content;
}

.modal-body-enregistrer {
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 1vh;
    padding-bottom: 1rem;
    width: 70%;
    margin-bottom: 15px;
}

.modal-footer-enregistrer {
    padding: 16px 16px;
    background-color: white;
    color: white;
    position: absolute;
    width: 100%;
    bottom: 0;
    right: 0;
}

</style>